import { getToken } from 'http/clientToken';
import ReservationIcon from './ReservationIcon';

import {
    BookingsIcon,
    BookingStatsIcon,
    CampaignIcon,
    ListIcon,
} from 'assets/materialIcons/materialIcons';

const menuStructureSpecification = () => {
    return {
        'travel-admin': [
            {
                resource: 'bookings',
                leftIcon: BookingsIcon,
                label: 'menu.sidebar.bookings',
                children: [],
            },
            {
                resource: 'reservations',
                leftIcon: ReservationIcon,
                label: 'menu.sidebar.reservations',
                children: [],
            },
            {
                resource: 'booking-stats',
                leftIcon: BookingStatsIcon,
                label: 'menu.sidebar.bookingStats',
                children: [],
            },
        ],
        'travel-provider': [
            {
                resource: 'products',
                leftIcon: ListIcon,
                label: 'menu.sidebar.products',
                children: [],
            },
            {
                resource: 'reservations',
                leftIcon: ReservationIcon,
                label: 'menu.sidebar.reservations',
                children: [],
            },
            {
                resource: 'booking-stats',
                leftIcon: BookingStatsIcon,
                label: 'menu.sidebar.bookingStats',
                children: [],
            },
        ],
        'publisher': [
            {
                resource: 'bookings',
                leftIcon: BookingsIcon,
                label: 'menu.sidebar.bookings',
                children: [],
            },
            {
                resource: 'campaigns',
                leftIcon: CampaignIcon,
                label: 'menu.sidebar.campaigns',
                children: [],
            },
        ],
    };
};

export const adminSystemSpecification = () => {
    const cat = getToken();
    const nextUrl = process.env.REACT_APP_DASH_NEXT_URL;

    return {
        'travel-admin': [
            ...(nextUrl ? [
                {
                    resource: 'assets',
                    label: 'menu.sidebar.assets',
                    children: [],
                    url: `${ nextUrl }/assets?cat=${ cat }`,
                },
            ] : []),
            {
                resource: 'accounts',
                label: 'menu.sidebar.accounts',
                children: [],
            },
            {
                resource: 'discounts',
                label: 'menu.sidebar.discounts',
                children: [],
            },
            {
                resource: 'invoices',
                label: 'menu.sidebar.invoices',
                children: [],
            },
            {
                resource: 'membership-schedules',
                label: 'menu.sidebar.membership_schedules',
                children: [],
            },
            {
                resource: 'membership-pools',
                label: 'menu.sidebar.membership_pools',
                children: [],
            },
            {
                resource: 'pointsofinterest',
                label: 'menu.sidebar.points_of_interest',
                children: [],
            },
            {
                resource: 'products',
                label: 'menu.sidebar.products',
                children: [],
            },
            {
                resource: 'product-memberships',
                label: 'menu.sidebar.product_memberships',
                children: [],
            },
            {
                resource: 'properties',
                label: 'menu.sidebar.properties',
                children: [],
            },
            {
                resource: 'propertygroups',
                label: 'menu.sidebar.propertygroups',
                children: [],
            },
            {
                resource: 'subcategories',
                label: 'menu.sidebar.subcategories',
                children: [],
            },
            {
                resource: 'users',
                label: 'menu.sidebar.users',
                children: [],
            },
            {
                resource: 'account_yields',
                label: 'menu.sidebar.account_yields',
                children: [],
            },
        ],
    };
};

export const ownerAccountAdminSpecification = () => {
    return {
        'travel-admin': [
            {
                resource: 'current-account',
                label: 'menu.sidebar.account_details',
                children: [],
            },
            {
                resource: 'api-keys',
                label: 'menu.sidebar.api-keys',
                children: [],
            },
            {
                resource: `current-account/invitations`,
                label: 'menu.sidebar.users',
                children: [],
            },
        ],
        'travel-provider': [
            {
                resource: `current-account`,
                label: 'menu.sidebar.account_details',
                children: [],
            },
            {
                resource: 'api-keys',
                label: 'menu.sidebar.api-keys',
                children: [],
            },
            {
                resource: 'webhooks',
                label: 'menu.sidebar.webhooks',
                children: [],
            },
            {
                resource: `current-account/invitations`,
                label: 'menu.sidebar.users',
                children: [],
            },
        ],
        'publisher': [
            {
                resource: `current-account`,
                label: 'menu.sidebar.account_details',
                children: [],
            },
            {
                resource: 'api-keys',
                label: 'menu.sidebar.api-keys',
                children: [],
            },
            {
                resource: 'webhooks',
                label: 'menu.sidebar.webhooks',
                children: [],
            },
            {
                resource: `current-account/invitations`,
                label: 'menu.sidebar.users',
                children: [],
            },
        ],
    };
};

export default menuStructureSpecification;



// WEBPACK FOOTER //
// ./src/components/layout/Menu/index.js